import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Project } from 'src/app/interfaces/project';
import { SmartReportingNotice } from 'src/app/interfaces/smart-reporting-notice';
import { SmartReportingService } from 'src/app/services/smart-reporting.service';
import { DateHelper } from 'src/app/utils/date-helper';
import { SmartReportingMapPage } from '../../../../modules/smart-reporting/pages/map/map.page';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { CardComponent } from 'src/app/components/cards/card/card.component';
import { DivClickDirective } from 'src/app/directives/div-click.directive';
import { InlineSVGModule } from 'ng-inline-svg-2';

@Component({
  selector: 'app-project-smart-reporting',
  templateUrl: './project-smart-reporting.component.html',
  standalone: true,
  imports: [
    SmartReportingMapPage,
    NgFor,
    DatePipe,
    LoaderComponent,
    NgIf,
    CardComponent,
    DivClickDirective,
    InlineSVGModule,
  ],
})
export class ProjectSmartReportingComponent implements OnInit {
  @Input() project: Project;
  notices: SmartReportingNotice[] = [];
  loading: boolean = true;
  @Input() active: boolean;
  DateHelper = DateHelper;

  constructor(
    private smartReportingService: SmartReportingService,
    private router: Router
  ) {
    this.smartReportingService.noticeSubmitted$.subscribe(() => {
      this.getNotices();
    });
    this.smartReportingService.replied$.subscribe(() => {
      this.getNotices();
    });
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.active.currentValue) {
      this.getNotices();
    }
  }

  openNotice(notice: SmartReportingNotice) {
    this.router.navigate(
      ['projects', this.project.slug, 'smart-reporting', notice.id],
      {
        state: { notice: notice },
      }
    );
  }

  async getNotices() {
    this.notices = [];
    this.loading = true;
    try {
      this.notices = await this.smartReportingService.listSubscribed(
        this.project
      );
      this.notices.map(
        (notice) =>
          (notice.lastInteractionDate = new Date(
            notice.responses?.length > 0
              ? notice.responses[notice.responses.length - 1].createdAt
              : notice.createdAt
          ))
      );
      this.notices.sort(
        (c1, c2) =>
          c2.lastInteractionDate.getTime() - c1.lastInteractionDate.getTime()
      );
    } catch (error) {
      // ignore
    } finally {
      this.loading = false;
      this.smartReportingService.updateLastViewData(this.project);
    }
  }
}
